import ButtonGroup from '../../wui-button-group/src'
import Button from './Button'

Button.Group = ButtonGroup
export default Button

